import React, { FC, useState } from "react";
import { TrainableTable } from "../markup/referenceViewer/trainableTables";
import { DisplayRow, TrainingTableGrid } from "./trainingTable";
import { Message, PrimaryButton, TableTitle } from "./trainUi";

interface SequentialTrainingProps {
    tables: TrainableTable[];
}

function fullRows(table: TrainableTable): DisplayRow[] {
    return table.rows.map(row => ({ cells: row.cells, revealedColumns: table.colCount }));
}

export const SequentialTraining: FC<SequentialTrainingProps> = ({ tables }) => {
    const [tableIndex, setTableIndex] = useState(0);
    const [rowIndex, setRowIndex] = useState(0);
    const [done, setDone] = useState(false);

    const advance = () => {
        const currentTable = tables[tableIndex];
        if (rowIndex + 1 < currentTable.rows.length) {
            setRowIndex(rowIndex + 1);
        } else if (tableIndex + 1 < tables.length) {
            setTableIndex(tableIndex + 1);
            setRowIndex(0);
        } else {
            setDone(true);
        }
    };

    return (
        <div>
            {tables.map((table, index) => {
                if (index > tableIndex)
                    return null;

                let rows: DisplayRow[];
                if (done || index < tableIndex) {
                    rows = fullRows(table);
                } else {
                    rows = table.rows.slice(0, rowIndex).map(row => ({
                        cells: row.cells,
                        revealedColumns: table.colCount,
                    }));
                    const current = table.rows[rowIndex];
                    rows.push({
                        cells: current.cells,
                        revealedColumns: 1,
                    });
                }

                return (
                    <div key={index}>
                        {table.title.length > 0 && <TableTitle>{table.title}</TableTitle>}
                        <TrainingTableGrid header={table.header} colCount={table.colCount} rows={rows} />
                    </div>
                );
            })}

            {done ? (
                <Message>All tables done ✓</Message>
            ) : (
                <PrimaryButton type="button" onClick={advance}>Show answer</PrimaryButton>
            )}
        </div>
    );
};
